import { ListCountEstimateMode, ListCountRequestMode } from 'notable-common';
import { z } from 'zod';
import { FlowState } from './enums.js';
export const FLOW_LIST_DEFAULT_LIMIT = 20;
export const FLOW_LIST_MAX_LIMIT = 100;
const FlowListCursorSchema = z
    .string()
    .min(1)
    .max(2_048)
    .regex(/^[A-Za-z0-9_-]+$/);
export const FlowListV2QuerySchema = z
    .object({
    nameSearch: z
        .string()
        .min(3)
        .max(200)
        .describe('Case-insensitive substring of the flow name.')
        .optional(),
    organizationId: z.uuid().optional(),
    agentId: z.uuid().optional(),
    state: z
        .enum(FlowState)
        .describe('Return only flows in this state. Omit to include Active and Inactive flows while excluding SoftDeleted flows; set SoftDeleted to find deleted flows.')
        .optional(),
    limit: z.coerce
        .number()
        .int()
        .positive()
        .max(FLOW_LIST_MAX_LIMIT)
        .optional()
        .default(FLOW_LIST_DEFAULT_LIMIT),
    cursor: FlowListCursorSchema.describe('Opaque exclusive paging cursor returned as nextCursor by the previous page.').optional(),
    countMode: z
        .enum(ListCountRequestMode)
        .describe('None omits the count. Exact scans every match. Estimated scans at most 4,097 matches and may return a capped lower estimate when more than 4,096 match.')
        .optional()
        .default(ListCountRequestMode.None),
})
    .strict();
export const FlowListItemSchema = z.object({
    id: z
        .uuid()
        .describe('Flow identifier, not a flow definition identifier. Use a non-null liveDefinitionId to retrieve the published definition.'),
    name: z.string(),
    descriptionPreview: z
        .string()
        .max(500)
        .nullable()
        .describe('First 250 Unicode characters of the flow description, or null when absent. Retrieve the flow for its complete description.'),
    state: z.enum(FlowState),
    organizationId: z.uuid(),
    agentId: z.uuid().nullable().describe('Agent containing the flow, when assigned.'),
    agentName: z.string().nullable(),
    liveDefinitionId: z
        .uuid()
        .nullable()
        .describe('Published flow definition identifier, or null when the flow has no published definition. This differs from the flow id.'),
    updated: z.iso.datetime().describe('When the flow metadata was last updated.'),
});
export const FlowListResponseSchema = z.object({
    flows: z.array(FlowListItemSchema),
    paginationSummary: z
        .object({
        total: z.number().int().nonnegative(),
        status: z.enum(ListCountEstimateMode),
    })
        .describe('Match count and its accuracy status. When status is Estimated, total is a capped lower estimate.')
        .optional(),
    limit: z.number().int().positive().max(FLOW_LIST_MAX_LIMIT),
    nextCursor: FlowListCursorSchema.nullable().describe('Opaque cursor for the next page, or null when this is the final page.'),
});
//# sourceMappingURL=list.js.map